module.exports = __webpack_public_path__ + "04_short_black.834d898a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/04_short_black.png
// module id = JbP/
// module chunks = 0